<template>
  <div class="countDown_container">
    <div class="content">
      <slot
        v-bind="{
          d: days,
          h: hours,
          m: mins,
          s: seconds,
          dd: `00${days}`.slice(-2),
          hh: `00${hours}`.slice(-2),
          mm: `00${mins}`.slice(-2),
          ss: `00${seconds}`.slice(-2),
        }"
      ></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountDown",
  props: {
    time: {
      type: [Number, String],
      default: 0,
    },
    isMilliSecond: {
      type: Boolean,
      default: false,
    },
    end: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      timer: null,
      curTime: 0,
      days: 0,
      hours: 0,
      mins: 0,
      seconds: 0,
    };
  },
  computed: {
    durationTime() {
      if (this.end > 0) {
        let end = String(this.end).length >= 13 ? +this.end : +this.end * 1000;
        end -= Date.now();
        return end;
      }

      const time = this.isMilliSecond
        ? Math.round(+this.time / 1000)
        : Math.round(+this.time);
      return time;
    },
  },
  methods: {
    //计算倒计时
    countDown() {
      this.curTime = Date.now();
      this.getTime(this.durationTime);
    },
    //获取当前的时间
    getTime(durationTime) {
      this.timer && clearTimeout(this.timer);
      if (durationTime <= 0) {
        return false;
      }
      const { daysVal, hoursVal, minsVal, secondsVal } =
        this.durationFormatter(durationTime);
      this.days = daysVal || 0;
      this.hours = hoursVal || 0;
      this.mins = minsVal || 0;
      this.seconds = secondsVal || 0;

      this.timer = setTimeout(() => {
        const now = Date.now();
        const diffTime = Math.floor((now - this.curTime) / 1000);
        this.curTime = Date.now();
        this.getTime(durationTime - diffTime);
      }, 1000);
    },
    //格式化获取当前的时间 天/时/分/秒
    durationFormatter(durationTime) {
      if (!durationTime) return { secondsVal: 0 };

      let timeVal = durationTime;
      const secondsVal = timeVal % 60;
      timeVal = (timeVal - secondsVal) / 60;
      if (timeVal < 1) return { secondsVal };

      const minsVal = timeVal % 60;
      timeVal = (timeVal - minsVal) / 60;
      if (timeVal < 1) return { minsVal, secondsVal };

      const hoursVal = timeVal % 24;
      timeVal = (timeVal - hoursVal) / 24;
      if (timeVal < 1) return { hoursVal, minsVal, secondsVal };

      const daysVal = timeVal;
      return { daysVal, hoursVal, minsVal, secondsVal };
    },
  },
  mounted() {
    this.countDown();
  },
  watch: {
    durationTime() {
      this.countDown();
    },
  },
};
</script>

<style scoped>
.countDown_container {
  height: 200px;
  width: 200px;
  background: url(~@/assets/countDownImg.png) 100% 100% no-repeat;
  color: #fff;
  overflow: hidden;
}

.content {
  margin-top: 114px;
}
</style>
